"use client";

import { useSelection } from "@frend-digital/centra/client";

export const useCart = () => {
  return useSelection({
    select: data => ({
      items: data?.selection?.items,
      itemCount: data?.selection?.items?.length,
      totalQuantity: data?.selection?.totals.totalQuantity,
      itemsTotalPrice: data?.selection?.totals?.itemsTotalPrice,
      itemsTotalPriceAsNumber: data?.selection?.totals.itemsTotalPriceAsNumber,
      grandTotalPrice: data?.selection?.totals.grandTotalPrice,
      grandTotalPriceAsNumber: data?.selection?.totals.grandTotalPriceAsNumber,
      shippingPriceAsNumber: data?.selection?.totals?.shippingPriceAsNumber,
      shippingPrice: data?.selection?.totals?.shippingPrice,
    }),
  });
};

export type CartItem = NonNullable<
  NonNullable<CartHook["data"]>["items"]
>[number];

export type CartHook = ReturnType<typeof useCart>;
